function fn_comp_visual() {
    var $fn = $(".comp_visual"),
        $slider = $fn.find("[data-visual-slider]"),
        $data_slider_autoplay = $slider.data("visual-slider"),
        $arrow_prev = $slider.next(".wrp_comp_arrows").find(".slick-prev"),
        $arrow_next = $slider.next(".wrp_comp_arrows").find(".slick-next");

    if ($slider.children().length > 1) {
        $slider.slick({
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: $data_slider_autoplay,
            arrows: true,
            dots: false,
            nextArrow: $arrow_next,
            prevArrow: $arrow_prev
        });
        $slider.on('afterChange', function(){
            $(this).find(".slick-active").find("img").addClass("lazyload");
        });
    }
}